import ApiConstants, { AA } from "./ApiConstants";
import { customToast } from "../utils/General";
import axios from "axios";

let options;

export default async function api(
  path,
  params,
  token = null,
  method = "post",
  basic = null,
  timeout = 0
) {
  let _token = token;
  if (!_token) {
    _token = localStorage.getItem("Token");
  }
  options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ApiKey: `${AA}`,
      ...(_token && { Authorization: `Bearer ${_token}` }),
      ...(basic && { Authorization: `Basic ${basic}` }),
    },
    method,
    ...(params && { data: params }),
    timeout: timeout,
  };
  try {
    const data = await axios(ApiConstants.BASE_URL + path, options);
    console.log("%c >>> Request: >>>", "color: #00d4ff", {
      host: ApiConstants.BASE_URL,
      path,
      options,
    });
    console.log("%c <<< Response: <<<", "color: #3cb371", data);
    return {
      status: data?.status,
      ...data,
      message: data?.data?.message?.pr || data?.data?.message,
    };
  } catch (error) {
    if (error.response) {
      if (error.response?.status === 401 && error.response?.data?.code === -5) {
        customToast("error", "نیاز به ورود مجدد.", {
          onClose: () => {
            window.location.replace("/#/login");
            localStorage.clear();
          },
        });
      } else if (
        error.response?.status === 401 &&
        error.response?.data?.code === -34
      ) {
        customToast("error", "نام کاربری یا رمز عبور نادرست است.");
      } else if (
        error.response?.status === 403 &&
        error.response?.data?.code === -36
      ) {
        customToast("error", "شما اجازه دسترسی به این بخش را ندارید!");
      } else if (
        error.response?.status === 401 &&
        error.response?.data?.code !== -34
      ) {
        window.location.replace("/#/login");
        localStorage.clear();
      } else if (error.response?.status === 403) {
        customToast("error", "خطا در ارتباط با سرور", {
          onClose: () => {
            window.location.replace("/#/login");
            localStorage.clear();
          },
        });
      }
      return error.response;
    } else if (error.response === undefined) {
      customToast("error", "خطا در ارتباط با سرور");
    }
  }
}

export function xhrUpload(url, opts = {}, onProgress) {
  return new Promise((res, rej) => {
    const xhr = new XMLHttpRequest();
    xhr.open(opts.method || "get", url);
    for (let k in opts.headers || {}) xhr.setRequestHeader(k, opts.headers[k]);
    xhr.onload = (e) => res(e.target.responseText);
    xhr.onerror = rej;
    if (xhr.upload && onProgress) xhr.upload.onprogress = onProgress;
    xhr.send(opts.body);
  });
}
